import { render } from "./detail.vue?vue&type=template&id=d0cd3a9c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=d0cd3a9c&lang=css"
import "./detail.vue?vue&type=style&index=1&id=d0cd3a9c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/frontend-offical-website/master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0cd3a9c"]])

export default __exports__